import { assetGroupIsLut } from '@/features/Downloads/Gateway/internal/assetGroupIsLut';

import type { AssetGroup } from '@/types/asset';
import type { MGStyles, MGThemes, MGTypes } from '@music-vine/setlist';

/**
 * Creates asset information object for upsell modal based on asset type
 * Handles different asset types (motion graphics, music, SFX) with their specific properties
 * @param assetData - The asset data to extract information from
 * @returns Formatted asset information object for upsell modal
 */
export const createAssetInfo = (assetData: AssetGroup) => {
  if (assetData.type === 'motion') {
    return {
      assetType: assetData.type,
      assetName: assetData.data.name,
      contributorName: assetData.data.contributor?.name ?? '',
      contributorImage: undefined,
      assetThumbnail: assetData.data.image,
      isLut: assetGroupIsLut({ asset: assetData }),
      isNew: assetData.data.is_new ?? false,
      isPremium: assetData.data.is_premium,
      types:
        (assetData.data as unknown as { types?: MGTypes })?.types?.map(
          (type) => type.id
        ) ?? [],
      themes:
        (assetData.data as unknown as { themes?: MGThemes })?.themes?.map(
          (theme) => theme.id
        ) ?? [],
      styles:
        (assetData.data as unknown as { styles?: MGStyles })?.styles?.map(
          (style) => style.id
        ) ?? [],
      tags:
        (assetData.data as unknown as { keywords?: string[] })?.keywords ?? [],
    };
  }

  if (assetData.type === 'stock_footage') {
    return {
      assetType: assetData.type,
      assetName: assetData.data.name,
      contributorName: assetData.data.contributor_name ?? '',
      contributorImage: undefined,
      assetThumbnail: assetData.data.thumbnail_url,
      isNew: assetData.data.is_new ?? false,
      isPremium: assetData.data.is_premium ?? false,
      themes: [],
      tags: assetData.data?.keywords ?? [],
    };
  }

  return {
    assetType: assetData.type,
    assetName: assetData.data.name,
    contributorName: assetData.data.artist?.name ?? '',
    contributorImage:
      assetData.data.sfx_classification_id?.preview_image ??
      assetData.data.artist?.avatar_image?.image_aws_url,
    assetThumbnail: assetData.data.sfx_classification_id?.preview_image,
    isNew: assetData.data.is_new ?? false,
    isPremium: assetData.data.is_premium ?? false,
    isCustom: Boolean(assetData.data.adaptive),
    tags:
      (
        assetData.data as unknown as {
          tags?: Array<{ name: string }>;
        }
      )?.tags?.map((tag) => tag.name) ?? [],
  };
};
